export const SHOPY_URL = 'https://menu.tucan.la/LaPinocha?utm_source=landing';
